/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_sig_type_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The downloaded PNG is rendered at a high resolution that scales down cleanly. You can resize it in any document or image editor after downloading.`)
};

const es_sig_type_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`El PNG descargado se renderiza en una resolución alta que se escala limpiamente. Puedes redimensionarlo en cualquier editor de documentos o imágenes después de descargar.`)
};

const de_sig_type_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Das heruntergeladene PNG wird mit einer hohen Auflösung gerendert, die sauber herunterskaliert. Sie können die Größe nach dem Download in einem beliebigen Dokument- oder Bildbearbeitungsprogramm ändern.`)
};

const nl_sig_type_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`De gedownloade PNG wordt weergegeven met hoge resolutie die schoon omlaag schaalt. U kunt het na het downloaden in een document- of afbeeldingseditor vergroten of verkleinen.`)
};

const fr_sig_type_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Le PNG téléchargé est rendu à une haute résolution qui s'adapte proprement. Vous pouvez le redimensionner dans n'importe quel éditeur de document ou d'image après le téléchargement.`)
};

const it_sig_type_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Il PNG scaricato viene renderizzato ad alta risoluzione che scala verso il basso in modo pulito. Puoi ridimensionarlo in qualsiasi editor di documenti o immagini dopo il download.`)
};

const pt_br2_sig_type_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O PNG baixado é renderizado em alta resolução que redimensiona perfeitamente. Você pode redimensioná-lo em qualquer editor de documento ou imagem após baixar.`)
};

const pt_sig_type_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O PNG descarregado é renderizado numa alta resolução que se redimensiona com limpeza. Pode redimensioná-lo em qualquer editor de documento ou imagem após descarregar.`)
};

const ja_sig_type_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ダウンロードされたPNGは、きれいにスケールダウンする高解像度でレンダリングされます。ダウンロード後、任意のドキュメントまたは画像エディターでサイズを変更できます。`)
};

const zh_sig_type_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`下载的 PNG 以高分辨率渲染，可以清晰地缩小。下载后，您可以在任何文档或图像编辑器中调整其大小。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const sig_type_faq2_a = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.sig_type_faq2_a(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("sig_type_faq2_a", locale)
	if (locale === "en") return en_sig_type_faq2_a(inputs)
	if (locale === "es") return es_sig_type_faq2_a(inputs)
	if (locale === "de") return de_sig_type_faq2_a(inputs)
	if (locale === "nl") return nl_sig_type_faq2_a(inputs)
	if (locale === "fr") return fr_sig_type_faq2_a(inputs)
	if (locale === "it") return it_sig_type_faq2_a(inputs)
	if (locale === "pt-BR") return pt_br2_sig_type_faq2_a(inputs)
	if (locale === "pt") return pt_sig_type_faq2_a(inputs)
	if (locale === "ja") return ja_sig_type_faq2_a(inputs)
	return zh_sig_type_faq2_a(inputs)
};